import languageConstants from '../constants/languageConstants';

const initialState = {
  languages: [],
};

export default function language(state = initialState, action) {
  switch (action.type) {
    case languageConstants.GET_LANGUAGES_REQUEST:
      return {
        ...state,
        requesting: true,
      };
    case languageConstants.GET_LANGUAGES_SUCCESS:
      return {
        ...state,
        requesting: false,
        languages: action.languages,
      };
    case languageConstants.GET_LANGUAGES_FAILURE:
      return {
        ...state,
        requesting: false,
      };
    default:
      return state;
  }
}
